"use client";

import React from "react";
import Section from "@/components/ui/section";
import { ResourceItem } from "@/components/Resources";
import type { TeamMemberPost } from "@/lib/team-member-posts";

export function TeamMemberPosts({
  memberName,
  posts,
}: {
  memberName?: string | null;
  posts: TeamMemberPost[];
}) {
  // Drafts are present only when the server rendered in Draft Mode.
  const visiblePosts = React.useMemo(
    () =>
      [...(posts || [])].sort((a, b) => {
        const aTime = a.publishDate ? new Date(a.publishDate).getTime() : 0;
        const bTime = b.publishDate ? new Date(b.publishDate).getTime() : 0;
        return bTime - aTime;
      }),
    [posts]
  );

  if (!visiblePosts.length) return null;

  return (
    <Section wrapperClassName="!pt-12 light-wrapper light:!bg-white" id="posts">
      <div className="flex flex-col gap-8">
        <h2 className="h4">
          {memberName
            ? `Posts by ${memberName} (${visiblePosts.length})`
            : `Articles (${visiblePosts.length})`}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {visiblePosts.map((post) => (
            <ResourceItem
              key={post.id}
              resource={post}
              viewMode="grid"
              animateOnHover={false}
            />
          ))}
        </div>
      </div>
    </Section>
  );
}
